import translations from './translations'

translations.add('is', {
    mainDescription: 'Verið er að vinna úr greiðslunni þinni',
    tokenizationDescription: 'Kortaskráning í ferli',
    verificationDescription: 'Staðfesting korts í ferli',
    secondaryDescription: 'Vinsamlegast hinkrið, ekki loka eða endurnýja síðuna'
})
